import React from "react";
import { useTransition, animated } from "@react-spring/web";
import { Container } from "./styled-components";

export interface AnimatedContainerProps {
  isVisible: boolean;
  isExtendedSelection?: boolean;
  isFloating?: boolean;
  children: React.ReactNode;
}

const AnimatedContainer = animated(Container);

const AnimatedExtendedSelectionsContainer = ({
  isVisible,
  isExtendedSelection = false,
  isFloating = true,
  children
}: AnimatedContainerProps) => {
  const transition = useTransition(isVisible, {
    config: { duration: isFloating ? 200 : 0 },
    from: { opacity: 0, transform: `translate3d(0px, 13px, 0px)` },
    enter: { opacity: 1, transform: `translate3d(0px, 0px, 0px)` },
    leave: { opacity: 0, transform: `translate3d(0px, 13px, 0px)` }
  });

  return (
    <>
      {transition(
        (styles, isOpen) =>
          isOpen && (
            <AnimatedContainer
              style={styles}
              isExtendedSelection={isExtendedSelection}
              isFloating={isFloating}
              data-qa-label="bet-slip-extended-selections-wrapper"
            >
              {children}
            </AnimatedContainer>
          )
      )}
    </>
  );
};

export default AnimatedExtendedSelectionsContainer;
